import {Button, Card, Link, CardHeader} from "@nextui-org/react";
import {FaChevronLeft, FaChevronRight} from "react-icons/fa6";
import {useEffect, useState} from "react";
import Swipe from "react-easy-swipe";

import { HOMEPAGE_DATA_TYPE } from "@/components/helpers/constant";
import SharedService from "@/services/shared-service";

var _ = require('lodash');

/**
 *
 * @param {Object} documentContent
 * @returns {JSX.Element}
 */
function DocumentContent(documentContent) {
    return (
        <>
            <Link href={SharedService.getPostPath(documentContent.data)} className="block">
                <div className="relative text-center px-5">
                    <div className="text-white text-justify sm:text-center mt-5 text-xl mx-auto md:px-9">
                        <span className="inline-block" dangerouslySetInnerHTML={{__html: documentContent.data?.metaDescription}}></span>
                    </div>
                    <div className="text-center mt-10 mb-2 text-xl mx-auto px-9 font-bold text-white">
                        {documentContent.data?.quotation ? `${documentContent.data?.quotation} - ${documentContent.data?.title}` : documentContent.data?.title}
                    </div>
                </div>
            </Link>
        </>
    );
}

export default function DocumentsSlider({ data, type }) {
    const documents = data;
    const [currentSlide, setCurrentSlide] = useState(0);
    const currentType = HOMEPAGE_DATA_TYPE[type];
    const [pointer, setPointer] = useState(false);

    useEffect(() => {
        if (!pointer) {
            const timer = setInterval(() => {
                handleNextSlide();
            }, 5000);
            return () => clearInterval(timer);
        }
    }, [pointer, currentSlide]);

    // Actions Slide
    const handleNextSlide = () => {
        let newSlide = currentSlide === documents.value.length - 1 ? 0 : currentSlide + 1;
        setCurrentSlide(newSlide);
    };
    const handlePrevSlide = () => {
        let newSlide = currentSlide === 0 ? documents.value.length - 1 : currentSlide - 1;
        setCurrentSlide(newSlide);
    };

    return (
        <div onMouseEnter={() => setPointer(true)} onMouseLeave={() => setPointer(false)}>
            <Card className="rounded-none text-white py-5 !bg-cover !bg-center !bg-[url('/images/book-list.png')] !bg-blend-darken relative">
                <div className="absolute inset-0 bg-black opacity-70"></div>
                <CardHeader className="justify-center mt-3">
                    <div className="flex justify-between items-center">
                        <Button className="ml-5 md:ml-0 bg-primary" radius="full" isIconOnly size="sm"
                            aria-label="Previous" onClick={handlePrevSlide}>
                            <FaChevronLeft className="fill-white h-[32px] w-[32px] p-1"/>
                        </Button>

                        <div className="mx-10 text-2xl font-bold">
                            <Link
                                href={`/chuyen-de/${currentType?.link}`}
                                className="md:mx-10 text-2xl font-bold text-white whitespace-nowrap lg:text-3xl">
                                {currentType?.name.toLocaleUpperCase()}
                            </Link>
                        </div>

                        <Button className="mr-5 md:mr-0 bg-primary" radius="full" isIconOnly size="sm" aria-label="Next"
                            onClick={handleNextSlide}>
                            <FaChevronRight className="fill-white h-[32px] w-[32px] p-1"/>
                        </Button>
                    </div>
                </CardHeader>

                <Swipe
                    onSwipeLeft={handleNextSlide}
                    onSwipeRight={handlePrevSlide}
                >
                    {documents.total > 0 && documents.value.map((document, index) => {
                            if (index === currentSlide) {
                                return (
                                    <div key={index}>
                                        <DocumentContent data={document}/>
                                    </div>
                                );
                            }
                        }
                    )}
                </Swipe>
            </Card>
        </div>
    )
}